import React, {FC, useEffect, useState} from "react";
import GatewayService from "../../service/GatewayService";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import AppConstants from "../../util/AppConstants";
import {ComboList} from "./OptionsOppComponent";
import AppUtil from "../../util/AppUtil";
import {Combo} from "../../models/Combo";
import {useClients} from "../../context/ClientsContext";

interface Props {
}
const SqOffFuturesComp:FC<Props> = () => {
    const [optimisedCombos, setCombosOptimised] = useState<Array<Combo>>([]);
    const [client, setClient] = useState("");
    const[timestamp, setTimestamp] = useState(0);
    const { clients } = useClients();

    useEffect(() => {
        if (clients && clients.length > 0 && client === "") {
            setClient(clients[0]);
        }
    }, [clients, client]);

    useEffect(() => {
        if (client) {
            GatewayService.getOpportunityForFutureSqOff(client).then(setCombosOptimised)
        }
    }, [timestamp, client]);

    return<>
        <DropDownCompString text={"select client"} actual={client} arr={getKeyVal(clients)} set={setClient}/>
        <button onClick={()=>setTimestamp(AppUtil.currentTime)}>refresh</button>
        <ComboList combos={optimisedCombos} clientId={client}/>
    </>
}

export default SqOffFuturesComp